import { allTrackers } from "app/services/track/track";

import createDemoModeTrackingService from "./factory";

const demoModeTrackingService = createDemoModeTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default demoModeTrackingService;
